export type IcMenuItemVariants = "toggle" | "destructive" | "default";
